import { z } from 'zod'

import { baseStructuredSchema } from '@/pages/instruments/new-instrument/schemas/shared/base-structured.schema'
import { contractTypeSchema } from '@/pages/instruments/new-instrument/schemas/shared/contract-type.schema'
import { knockdownInputLevelSchema } from '@/pages/instruments/new-instrument/schemas/shared/knockdown-input-level.schema'
import { sideSchema } from '@/pages/instruments/new-instrument/schemas/shared/side.schema'

export const digitalSchema = baseStructuredSchema.extend({
  instrument_type: z.literal('digital'),

  contract_type: contractTypeSchema,
  side: sideSchema,
  coupon_rate_annual: z.number(),
  payoff_barrier_level: z.number(),

  knockdown_input_level: knockdownInputLevelSchema,
})

export type DigitalSchemaType = z.infer<typeof digitalSchema>
